/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v11.19.2.0 (NJsonSchema v9.10.73.0 (Newtonsoft.Json v9.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { ApiException } from "./common/ApiException";

export class ReporterService {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl ? baseUrl : "";
  }

  /**
   * Creates new report
   * @param report New report
   * @return Cre
   */
  createReport(report: NewReportDto | null): Promise<ReportDto | null> {
    let url_ = this.baseUrl + "/api/v0/reports";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(report);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreateReport(_response);
    });
  }

  protected processCreateReport(response: Response): Promise<ReportDto | null> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 ? ReportDto.fromJS(resultData200) : <any>null;
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<ReportDto | null>(<any>null);
  }

  /**
   * Gets reports array
   * @param page (optional)
   * @param pageSize (optional)
   * @param name (optional)
   * @param startTime (optional)
   * @param endTime (optional)
   * @param sortBy (optional)
   * @param order (optional)
   * @return Array of reports
   */
  getReports(
    page: number | undefined,
    pageSize: number | undefined,
    name: string | null | undefined,
    startTime: Date | null | undefined,
    endTime: Date | null | undefined,
    sortBy: string | null | undefined,
    order: SortOrder | undefined
  ): Promise<ReportPageDto | null> {
    let url_ = this.baseUrl + "/api/v0/reports?";
    if (page === null) throw new Error("The parameter 'page' cannot be null.");
    else if (page !== undefined) url_ += "Page=" + encodeURIComponent("" + page) + "&";
    if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
    if (name !== undefined) url_ += "Name=" + encodeURIComponent("" + name) + "&";
    if (startTime !== undefined)
      url_ += "StartTime=" + encodeURIComponent(startTime ? "" + startTime.toJSON() : "") + "&";
    if (endTime !== undefined) url_ += "EndTime=" + encodeURIComponent(endTime ? "" + endTime.toJSON() : "") + "&";
    if (sortBy !== undefined) url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (order === null) throw new Error("The parameter 'order' cannot be null.");
    else if (order !== undefined) url_ += "Order=" + encodeURIComponent("" + order) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetReports(_response);
    });
  }

  protected processGetReports(response: Response): Promise<ReportPageDto | null> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then(_responseText => {       
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 ? ReportPageDto.fromJS(resultData200) : <any>null;
        
        return result200;
      });
    } else if (status === 400) {
      return response.text().then(_responseText => {
        return throwException("A server error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<ReportPageDto | null>(<any>null);
  }

  /**
   * Updates report
   * @return Array of reports
   */
  updateReport(modifiedReport: ModifiedReportDto | null): Promise<ReportDto | null> {
    let url_ = this.baseUrl + "/api/v0/reports";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(modifiedReport);

    let options_ = <RequestInit>{
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateReport(_response);
    });
  }

  protected processUpdateReport(response: Response): Promise<ReportDto | null> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 ? ReportDto.fromJS(resultData200) : <any>null;
        return result200;
      });
    } else if (status === 404) {
      return response.text().then(_responseText => {
        return throwException("A server error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<ReportDto | null>(<any>null);
  }

  /**
   * Gets report
   * @param id report id
   * @return The report
   */
  getReport(id: string): Promise<ReportDto | null> {
    let url_ = this.baseUrl + "/api/v0/reports/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetReport(_response);
    });
  }

  protected processGetReport(response: Response): Promise<ReportDto | null> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 ? ReportDto.fromJS(resultData200) : <any>null;
        return result200;
      });
    } else if (status === 404) {
      return response.text().then(_responseText => {
        return throwException("A server error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<ReportDto | null>(<any>null);
  }

  /**
   * Deletes report
   * @param id report id
   * @return No content if report deleted
   */
  deleteReport(id: string): Promise<void> {
    let url_ = this.baseUrl + "/api/v0/reports/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "DELETE",
      headers: {
        "Content-Type": "application/json"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDeleteReport(_response);
    });
  }

  protected processDeleteReport(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then(_responseText => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }
}

export class ReportDto implements IReportDto {
  id!: string;
  userId!: string;
  name!: string;
  reportType!: string;
  reportData!: string;
  creationTime!: Date;
  description?: string | undefined;

  constructor(data?: IReportDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data["id"];
      this.userId = data["userId"];
      this.name = data["name"];
      this.reportType = data["reportType"];
      this.reportData = data["reportData"];
      this.creationTime = data["creationTime"] ? new Date(data["creationTime"].toString()) : <any>undefined;
      this.description = data["description"];
    }
  }

  static fromJS(data: any): ReportDto {
    data = typeof data === "object" ? data : {};
    let result = new ReportDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["Id"] = this.id;
    data["UserId"] = this.userId;
    data["Name"] = this.name;
    data["ReportType"] = this.reportType;
    data["ReportData"] = this.reportData;
    data["CreationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["Description"] = this.description;
    return data;
  }
}

export interface IReportDto {
  id: string;
  userId: string;
  name: string;
  reportType: string;
  reportData: string;
  creationTime: Date;
  description?: string | undefined;
}

export class NewReportDto implements INewReportDto {
  name!: string;
  description?: string | undefined;
  reportType!: string;
  reportData!: string;

  constructor(data?: INewReportDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.name = data["Name"];
      this.description = data["Description"];
      this.reportType = data["ReportType"];
      this.reportData = data["ReportData"];
    }
  }

  static fromJS(data: any): NewReportDto {
    data = typeof data === "object" ? data : {};
    let result = new NewReportDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["Name"] = this.name;
    data["Description"] = this.description;
    data["ReportType"] = this.reportType;
    data["ReportData"] = this.reportData;
    return data;
  }
}

export interface INewReportDto {
  name: string;
  description?: string | undefined;
  reportType: string;
  reportData: string;
}

export class ReportPageDto implements IReportPageDto {
  data?: ReportDto[] | undefined;
  pagination?: PaginationDto | undefined;

  constructor(data?: IReportPageDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      if (data["data"] && data["data"].constructor === Array) {
        this.data = [];
        for (let item of data["data"]) this.data.push(ReportDto.fromJS(item));
      }
      this.pagination = data["pagination"] ? PaginationDto.fromJS(data["pagination"]) : <any>undefined;
    }
  }

  static fromJS(data: any): ReportPageDto {
    data = typeof data === "object" ? data : {};
    let result = new ReportPageDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (this.data && this.data.constructor === Array) {
      data["Data"] = [];
      for (let item of this.data) data["Data"].push(item.toJSON());
    }
    data["Pagination"] = this.pagination ? this.pagination.toJSON() : <any>undefined;
    return data;
  }
}

export interface IReportPageDto {
  data?: ReportDto[] | undefined;
  pagination?: PaginationDto | undefined;
}

export class PaginationDto implements IPaginationDto {
  totalItems!: number;
  page!: number;
  pageSize!: number;
  totalPages!: number;

  constructor(data?: IPaginationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.totalItems = data["totalItems"];
      this.page = data["page"];
      this.pageSize = data["pageSize"];
      this.totalPages = data["totalPages"];
    }
  }

  static fromJS(data: any): PaginationDto {
    data = typeof data === "object" ? data : {};
    let result = new PaginationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["TotalItems"] = this.totalItems;
    data["Page"] = this.page;
    data["PageSize"] = this.pageSize;
    data["TotalPages"] = this.totalPages;
    return data;
  }
}

export interface IPaginationDto {
  totalItems: number;
  page: number;
  pageSize: number;
  totalPages: number;
}

export enum SortOrder {
  Asc = "Asc",
  Desc = "Desc"
}

export class ModifiedReportDto implements IModifiedReportDto {
  id!: string;
  name!: string;
  description?: string | undefined;

  constructor(data?: IModifiedReportDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data["Id"];
      this.name = data["Name"];
      this.description = data["Description"];
    }
  }

  static fromJS(data: any): ModifiedReportDto {
    data = typeof data === "object" ? data : {};
    let result = new ModifiedReportDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["Id"] = this.id;
    data["Name"] = this.name;
    data["Description"] = this.description;
    return data;
  }
}

export interface IModifiedReportDto {
  id: string;
  name: string;
  description?: string | undefined;
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): any {
  if (result !== null && result !== undefined) throw result;
  else throw new ApiException(message, status, response, headers, null);
}



// WEBPACK FOOTER //
// ./src/services/reporter.service.ts